;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import { assetFragment, linkFragment } from 'lib/graphql/fragments';

import BlockEventNearby from './BlockEventNearby';

const query = /* GraphQL */ `
    ${assetFragment}
    ${linkFragment}

    query getBlock($id: String!, $preview: Boolean!) {
        blockNearbyEvent(preview: $preview, id: $id) {
            __typename
            headline {
                json
            }
            bodyCopy {
                json
            }
            link {
                ...EntryLink
            }
            backgroundColor
            regionCategory
            regions
            image {
                ...Asset
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockNearbyEvent },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockNearbyEvent;
}

const BlockEventNearbyServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return (
        <BlockEventNearby
            {...block}
            richTagline={block.richTagline}
            richHeadline={block.richHeadline}
        />
    );
};

export default BlockEventNearbyServer;
